import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Textarea,
  FormControl,
  FormLabel,
  Input,
  useToast,
} from "@chakra-ui/react";
import axios from "axios";
import StarRating from "../../Common/StarRating";

const FeedbackModal = ({ isOpen, onClose, onFeedbackSubmit }) => {
  const [name, setName] = useState("");
  const [feedback, setFeedback] = useState("");
  const [rating, setRating] = useState(0);
  const toast = useToast();

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        "https://backend-my-portfolio.onrender.com/api/feedback",
        {
          name,
          feedback,
          rating,
        }
      );
      if (response.status === 201) {
        toast({
          title: "Feedback enviado.",
          description: "Obrigado pelo seu feedback!",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
        setName("");
        setFeedback("");
        setRating(0);
        onFeedbackSubmit(response.data); // Atualize a lista de feedbacks localmente
        onClose();
      }
    } catch (error) {
      toast({
        title: "Erro.",
        description: "Não foi possível enviar o feedback.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Deixe seu feedback</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel>Nome</FormLabel>
            <Input
              placeholder="Seu nome"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Feedback</FormLabel>
            <Textarea
              placeholder="Seu feedback sobre o portfólio"
              value={feedback}
              onChange={(e) => setFeedback(e.target.value)}
            />
          </FormControl>
          <FormControl mt={4}>
            <FormLabel>Classificação</FormLabel>
            <StarRating rating={rating} setRating={setRating} />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
            Enviar
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancelar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FeedbackModal;
